import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { DialogWithIconInterface } from './dialog-with-icon.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-dialog-with-icon',
  templateUrl: './dialog-with-icon.component.html',
  styleUrls: ['./dialog-with-icon.component.scss']
})
export class DialogWithIconComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogWithIconInterface,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogWithIconComponent>,) { }

  ngOnInit() {
  }

  emitEvent(){
      this.onNoClick(true);
  }

  onNoClick(state?): void {
    this.dialogRef.close(state);
  }

}
